import React, { useState, createContext } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

export interface HowToSyncVideos {
  "STC_PartA.mp4":string,
  "STC_PartB.mp4":string,
  "STC_Google.mp4":string,
  "STC_iOS.mp4":string,
  "STC_Outlook.mp4":string
}
const howToSyncDefault:any = {
  "STC_PartA.mp4":"https://aircanada.sharepoint.com/sites/myACcess/Shared%20Documents/Videos/SyncToCalendar/STC_PartA.mp4",
  "STC_PartB.mp4":"https://aircanada.sharepoint.com/sites/myACcess/Shared%20Documents/Videos/SyncToCalendar/STC_PartB.mp4",
  "STC_Google.mp4":"https://aircanada.sharepoint.com/sites/myACcess/Shared%20Documents/Videos/SyncToCalendar/STC_Google.mp4",
  "STC_iOS.mp4":"https://aircanada.sharepoint.com/sites/myACcess/Shared%20Documents/Videos/SyncToCalendar/STC_iOS.mp4",
  "STC_Outlook.mp4":"https://aircanada.sharepoint.com/sites/myACcess/Shared%20Documents/Videos/SyncToCalendar/STC_Outlook.mp4"
};

const HowToSyncContext = createContext({
  loading: true,
  howToSyncVideos: howToSyncDefault as HowToSyncVideos,
  getVideos: () => {},
});

export const HowToSyncProvider = (props) => {
  const [loading, setLoading] = useState(true)
  const [howToSyncVideos, setHowToSyncVideos] = useState<HowToSyncVideos>(howToSyncDefault);
  const { user } = useAuth();
  const {setErrorCode} = useApiError();

  const getVideos = async () => {
    if (!user) {
      return;
    }
    try {
      setLoading(true);
      const videos = await API.get('crewlife', `/howtosync/videos`, {});
      if(Object.keys(videos).length){
        setHowToSyncVideos(videos);        
      }else{
        setHowToSyncVideos(howToSyncDefault);
      }
      setLoading(false);
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <HowToSyncContext.Provider 
    value={{loading, howToSyncVideos, getVideos}}>
      {props.children}
    </HowToSyncContext.Provider>
  );
};

export const useHowToSyncContext= () => {
return React.useContext(HowToSyncContext);
};
